<template>
  <path
    d="M19.35 10.0402C18.67 6.59018 15.64 4.00018 12 4.00018C9.11 4.00018 6.6 5.64018 5.35 8.04018C2.34 8.36018 0 10.9102 0 14.0002C0 17.3102 2.69 20.0002 6 20.0002H19C21.76 20.0002 24 17.7602 24 15.0002C24 12.3602 21.95 10.2202 19.35 10.0402ZM14 13.0002V17.0002H10V13.0002H7L11.65 8.35018C11.85 8.15018 12.16 8.15018 12.36 8.35018L17 13.0002H14Z"
  />
</template>
